// Data for the home page's hero console.
//
// It is an illustration of the kind of system we build, not a live feed and
// not a claim about a customer. Everything in it is generic infrastructure
// vocabulary: no client names, no real job ids, no numbers presented as
// results. Keeping it here rather than in the i18n dictionaries is deliberate,
// since these are technical tokens that stay identical in every language.

export const CONSOLE = {
  title: "pipeline.render-queue",
  meta: ["4 x H100", "vram 320 GB", "workers 12"],

  stagesLabel: "STAGES",
  stages: [
    { name: "ingest", state: "ok", tone: "done" },
    { name: "caption", state: "ok", tone: "done" },
    { name: "train", state: "3/6", tone: "active" },
    { name: "evaluate", state: "idle", tone: "idle" },
    { name: "package", state: "idle", tone: "idle" },
    { name: "publish", state: "idle", tone: "idle" },
  ],

  columns: [
    { key: "job", label: "JOB", width: "w-[110px]" },
    { key: "base", label: "BASE", width: "w-[150px]" },
    { key: "stage", label: "STAGE", width: "flex-1 min-w-[200px]" },
    { key: "vram", label: "VRAM", width: "w-[80px]" },
    { key: "state", label: "STATE", width: "w-[96px]" },
  ],

  rows: [
    { job: "j-4172", base: "wan-2.2", stage: "train step 4180 / 6000", vram: "71 GB", state: "running", tone: "accent" },
    { job: "j-4171", base: "sdxl-1.0", stage: "evaluate held-out set", vram: "24 GB", state: "queued", tone: "neutral" },
    { job: "j-4168", base: "ltx-video", stage: "package artefact + config", vram: "18 GB", state: "done", tone: "neutral" },
    { job: "j-4166", base: "sdxl-edit", stage: "ingest dedupe + crop", vram: "8 GB", state: "done", tone: "neutral" },
    { job: "j-4159", base: "wan-2.2", stage: "train step 6000 / 6000", vram: "68 GB", state: "failed", tone: "warn" },
  ],
};
